import { useEffect, useState } from "react";
import { toast } from "sonner";
import { StatusBadge } from "@/components/site/StatusBadge";
import { api, formatApiError } from "@/lib/api";
import { NIC_TZ, fmtIn } from "@/lib/schedule";

export function BookingsPanel() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/bookings").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const decide = (id, action) => api.post(`/admin/bookings/${id}/${action}`).then(() => { toast.success(action === "confirm" ? "Schedule confirmed · student notified" : "Declined · student asked to pick new dates"); load(); }).catch((e) => toast.error(formatApiError(e)));
  if (!rows) return null;
  if (!rows.length) return <p className="text-sm text-slate-500" data-testid="bookings-empty">No schedule requests yet.</p>;
  return (
    <div className="grid md:grid-cols-2 gap-5" data-testid="bookings-panel">
      {rows.map((b) => (
        <div key={b.id} className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-5" data-testid="booking-row">
          <div className="flex items-start justify-between gap-3">
            <div><p className="font-semibold text-[#0B2A4A]">{b.name || b.email}</p><p className="text-xs text-slate-500">{b.email} · student time zone {b.tz || "unknown"}</p></div>
            <StatusBadge status={b.status} />
          </div>
          <ol className="mt-4 flex flex-col gap-1 text-sm">
            {b.sessions.map((s) => (
              <li key={s.day} className="flex flex-wrap justify-between gap-2 border-b border-dashed border-[#0B2A4A]/10 py-1">
                <span><span className="font-mono-ui font-bold text-[#F08A3C] mr-2">DAY {s.day}</span>{fmtIn(s.start_utc, NIC_TZ)} <span className="text-xs text-slate-400">Nicaragua</span></span>
                {b.tz && b.tz !== NIC_TZ && <span className="text-xs text-slate-500">Student: {fmtIn(s.start_utc, b.tz, { hour: "numeric", minute: "2-digit" })}</span>}
              </li>
            ))}
          </ol>
          {b.status !== "confirmed" && b.status !== "declined" && (
            <div className="mt-4 flex gap-2">
              <button onClick={() => decide(b.id, "confirm")} className="rounded-lg bg-emerald-600 text-white px-4 py-2 text-sm font-semibold" data-testid="booking-confirm-btn">Confirm</button>
              <button onClick={() => decide(b.id, "decline")} className="rounded-lg border border-[#0B2A4A]/20 px-4 py-2 text-sm font-semibold" data-testid="booking-decline-btn">Decline</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
